import { initializeApp } from "firebase/app";
import { 
  initializeAuth, 
  indexedDBLocalPersistence, 
  connectAuthEmulator 
} from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore"; 
import { getFunctions, connectFunctionsEmulator, httpsCallable } from "firebase/functions"; 

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export the services
// FIX: Use initializeAuth with indexedDBLocalPersistence. 
// This resolves the iOS hanging issue where getAuth() + localStorage fails in Capacitor.
export const auth = initializeAuth(app, {
  persistence: indexedDBLocalPersistence
});

export const db = getFirestore(app);
const analytics = getAnalytics(app);
export const functions = getFunctions(app);

// --- NEW: Helper for calling Cloud Functions ---
export const callFirebaseFunction = async (functionName, data) => {
  const func = httpsCallable(functions, functionName);
  try {
    const result = await func(data);
    return result.data;
  } catch (error) {
    throw error;
  }
};
// --- END NEW HELPER ---


// --- EMULATOR SETUP (DISABLED) ---
// I have commented this out so localhost connects to the REAL Firebase project.
/*
if (window.location.hostname === "localhost") {
  console.log("Connecting to local Firebase emulators...");
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, "localhost", 8080);
  connectFunctionsEmulator(functions, "localhost", 5001);
}
*/

export default app;